import { LoadingSpinner } from "@/components/ui/LoadingSpinner/LoadingSpinner";

export const FormLoadingOverlay = () => {
  return (
    <div className="bg-background/95 pointer-events-auto absolute inset-0 z-50 flex items-center justify-center">
      <LoadingSpinner className="h-8 w-8" />
    </div>
  );
};
